"use client";

import { useEffect } from "react";
export function ServiceWorkerRegistration() {
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;
    if (!("serviceWorker" in navigator)) return;
    const register = () => {
      navigator.serviceWorker.register("/sw.js").catch(() => {
        // A failed registration must never break the app; the only cost is
        // the blank first paint it was there to remove.
      });
    };
    if (document.readyState === "complete") register();else window.addEventListener("load", register, {
      once: true
    });
    return () => window.removeEventListener("load", register);
  }, []);
  return null;
}